import fetch from "isomorphic-fetch";
import { z } from "zod";

import { handleError } from "@lib/utils/error";

import { withAccountAuthHeaders } from "./apiHelpers";
import { apiConf } from "./index";

const GetFlexiblePlanningResponseSchema = z.object({
    id: z.string(),
    startDate: z.string().transform((val) => new Date(val)),
    endDate: z.string().transform((val) => new Date(val)),
    weeklyVolume: z.number(),
    siders: z.number(),
    amplitudeStart: z.string(),
    amplitudeEnd: z.string(),
    include: z
        .object({
            holidays: z.boolean(),
            weekDays: z.boolean(),
            saturday: z.boolean(),
            sunday: z.boolean(),
        })
        .partial(),
});
export type GetFlexiblePlanningResponse = z.infer<typeof GetFlexiblePlanningResponseSchema>;

const message = "Get FlexiblePlanning";
export async function getFlexiblePlanning(taskId: string): Promise<GetFlexiblePlanningResponse> {
    try {
        const resp = await fetch(
            withAccountAuthHeaders(`${apiConf.BACK_URL}/tasks/${taskId}/flexible-planning`, {
                method: `GET`,
            }),
        );

        if (resp.status >= 400) {
            return Promise.reject(new Error(message));
        }

        return GetFlexiblePlanningResponseSchema.parse(await resp.json());
    } catch (e) {
        handleError(e, 500);
        return Promise.reject(e);
    }
}
